module.exports = __webpack_public_path__ + "media/assets/images/leanbit_home/nosco_ragazza_interfaccia-0224b740df1d83f3716c3dc216134b99.png";